"use client";

import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { PricingContent } from "@/components/layout/pricing-content";

interface PricingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PricingModal({ open, onOpenChange }: PricingModalProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} modal={false}>
      <SheetContent className="sm:max-w-6xl w-full h-full overflow-y-auto p-0" pushed={open}>
        <SheetHeader className="px-6 pt-6 pb-0">
          <SheetTitle className="text-2xl font-bold text-center">
            Upgrade Your Plan
          </SheetTitle>
        </SheetHeader>
        <div className="px-6 pb-6">
          <PricingContent />
        </div>
      </SheetContent>
    </Sheet>
  );
}